export enum BiozoomError {
    DEFAULT = 'DEFAULT',
    LIGHT_50 = 'LIGHT_50',
    LIGHT_60 = 'LIGHT_60',
    ERROR_70 = 'ERROR_70',
    ERROR_80 = 'ERROR_80',
    ERROR_100 = 'ERROR_100',
    DATA = 'DATA',
    BATTERY = 'BATTERY',
    BATTERY_LOW = 'BATTERY_LOW',
    SCANNER = 'SCANNER',
    WIFI = 'WIFI',
    PRODUCT = 'PRODUCT',
    HAND = 'HAND',
    LICENSE = 'LICENSE',
    SERVER = 'SERVER',
    PULSE = 'PULSE',
    OUTDATED = 'OUTDATED',
    ERROR_45 = 'ERROR_45',
    ERROR_44 = 'ERROR_44',
    USB = 'USB',
}
